import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'relativeTime',
  standalone: false,
})
export class RelativeTimePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: Date | string | number): string {
    const now = new Date();
    const date = new Date(value);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const ago = this.translate.instant('common.time.ago');

    if (seconds < 60) {
      return this.translate.instant('common.time.justNow');
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} ${
        minutes > 1
          ? this.translate.instant('common.time.minutes')
          : this.translate.instant('common.time.minute')
      } ${ago}`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return `${hours} ${
        hours > 1
          ? this.translate.instant('common.time.hours')
          : this.translate.instant('common.time.hour')
      } ${ago}`;
    } else {
      const days = Math.floor(seconds / 86400);
      return `${days} ${
        days > 1
          ? this.translate.instant('common.time.days')
          : this.translate.instant('common.time.day')
      } ${ago}`;
    }
  }
}
